var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"none","width":"90%","height":"100%","max-height":"90vh","min-height":"25rem"},attrs:{"src":_vm.iframeSrc,"allowTransparency":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }